const $ = require('jquery');

const animateCSS = (element, animation, prefix = 'animate__') =>
  // We create a Promise and return it
  new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`;
    const node = element;

    node.classList.add(`${prefix}animated`, animationName);

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd() {
      node.classList.remove(`${prefix}animated`, animationName);
      node.removeEventListener('animationend', handleAnimationEnd);

      resolve('Animation ended');
    }

    node.addEventListener('animationend', handleAnimationEnd);
  });

let $navbar = $('nav.navbar'),
    $nav = $navbar.find('.navbar-nav').clone(),
    $offcanvas = $('<nav id="offcanvas-menu"></nav>'),
    $navbarLogo = $navbar.find('.navbar-brand img').clone(),
    $logo = $('<div class="logo" />');

$logo.append($navbarLogo);
$logo.appendTo($offcanvas);

$nav.prop('class', 'nav flex-column');

// insert caret in each toggle link
$nav.find('ul.submenu').each((i, el) => {
    $(el).prev('a').append('<span class="caret"></span>');
});

$offcanvas.on('click', 'li.menu-item-has-children > a.nav-link', e => {

    e.stopPropagation();
    e.preventDefault();

    let $link = $(e.target).closest('a.nav-link'),
        $menu = $link.next('.submenu'),
        $li = $link.parent();

    $li.toggleClass('open');

});

$nav.appendTo($offcanvas);

$offcanvas.insertAfter($navbar);

$navbar.find('.navbar-toggler').click(e => {
    $('body').toggleClass('offcanvas-open');
});

$(document).click(e => {

    if(!$(e.target).hasClass('navbar-toggler') && !$(e.target).parent().hasClass('navbar-toggler') && $(e.target).closest('#offcanvas-menu').length == 0) {
        $("body").removeClass('offcanvas-open');
    }

});